const maxMobileWidth = 450;
const fullScreenModifier = {
    name: 'fullScreen',
    enabled: true,
    phase: 'beforeWrite',
    fn({ state }) {
        const viewPort = state.scrollParents.popper[1];
        const viewHeight = viewPort.height;
        const viewWidth = viewPort.width;
        if (viewHeight && viewWidth && viewWidth < maxMobileWidth) {
            state.styles.popper.transform = 'translate(0px, -10px)';
            state.styles.popper.height = `${viewHeight + 20}px`;
            state.styles.popper.width = '100%';
        }
        else {
            delete state.styles.popper.height;
        }
    },
};
export { fullScreenModifier };
//# sourceMappingURL=fullScreenModifier.js.map